import { ContractIAImportProcess } from '../../models/Entities/Contracts/ContractIAImportProcess';
import { ErrorType } from '../../models/HttpError';

export interface ContractIAImportState {
	// Último proceso IA de un contrato (puede ser null si nunca se ejecutó)
	lastProcess: ContractIAImportProcess | null;

	// Crear proceso de importación
	isCreatingProcess: boolean;
	successCreatingProcess: boolean | undefined;
	failOnCreatingProcess: boolean;

	// Obtener último proceso
	isGettingLastProcess: boolean;
	successGettingLastProcess: boolean | undefined;
	failOnGettingLastProcess: boolean;

	// Error general
	error?: ErrorType;
}

export const ContractIAImportUnloadState: ContractIAImportState = {
	lastProcess: null,

	// Crear
	isCreatingProcess: false,
	successCreatingProcess: undefined,
	failOnCreatingProcess: false,

	// Obtener último
	isGettingLastProcess: false,
	successGettingLastProcess: undefined,
	failOnGettingLastProcess: false,

	error: undefined
};

